import { SendGiftUpdateCollectionTemplate } from '@hero/components';

export default function SendGiftUpdateCollectionPage() {
  return <SendGiftUpdateCollectionTemplate />;
}
